/* limone-pdp shared page scripts (extracted 2026-08-18). Guarded: safe to include per-section. */
if(!window.__limonePdpBase){window.__limonePdpBase=1;
var __limoneReady=function(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();};
/* --- refpulse binder (was inline after review wall) --- */
(function(){
/* clinical-reference buttons self-press every 5s, starting the first time each is displayed
   (2026-08-08, Massimo). Covers .bb-ref (bodyband) and .openref (inside the gyno drawer —
   IO fires when the drawer opens since display:none never intersects). */
function init(){
  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('refpulse');io.unobserve(e.target);}
  }),{threshold:.4});
  document.querySelectorAll('.fla5 .openref,.fla5 .bb-ref').forEach(b=>io.observe(b));
}
/* deferred to DOMContentLoaded — kept from when this script sat above the bodyband; harmless
   now that the wall (and this script) moved below it (2026-08-08) */
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* --- live review count (was inline at end of template) --- */
__limoneReady(function(){
(function(){
  var __rcEl = document.querySelector('.rev-count');
  var FALLBACK_COUNT = __rcEl ? (parseInt((__rcEl.textContent||'').replace(/[^0-9]/g,''),10) || 2164) : 2164;  // Loox-synced metafield; the literal is the last-resort fallback if the metafield ever vanishes
  var LOCK_COUNT = false;     // 2026-08-15 (Massimo): unpinned — count renders from the loox.num_reviews metafield and the widget overwrite is live again. Set true + a literal FALLBACK_COUNT to pin.
  function fmt(n){ return Number(n).toLocaleString('en-US'); }
  function paint(count){
    var els = document.querySelectorAll('.rev-count');
    for(var i=0;i<els.length;i++){ els[i].textContent = fmt(count); }
  }
  paint(FALLBACK_COUNT);
  if(LOCK_COUNT) return;
  function readLoox(){
    var scope = document.getElementById('looxReviews')
      || document.querySelector('.loox-reviews-default, .loox-reviews-widget, [class*="loox"]');
    if(!scope) return false;
    var matches = (scope.textContent || '').match(/[\d,]{2,7}\s*Reviews/gi);
    if(!matches) return false;
    var max = 0;
    for(var i=0;i<matches.length;i++){
      var n = parseInt(matches[i].replace(/[^\d]/g,''), 10);
      if(n > max) max = n;
    }
    if(max > 0){ paint(max); return true; }
    return false;
  }
  if(document.readyState !== 'loading' && readLoox()) return;
  var tries = 0;
  var mo = new MutationObserver(function(){ if(readLoox() || ++tries > 60) mo.disconnect(); });
  mo.observe(document.documentElement, { childList:true, subtree:true });
  setTimeout(function(){ try{ mo.disconnect(); }catch(e){} }, 15000);
})();
});
/* --- autoplay watchdog (was inline at end of template) --- */
__limoneReady(function(){
(function(){
/* Autoplay watchdog (2026-08-09, Massimo): the airmech + howto loop videos carry the autoplay
   attribute, but Safari (esp. iOS Low Power Mode) can deny it and leave them frozen on the first
   frame with no retry. Kick play() every time one enters the viewport; pause offscreen to save
   battery. The hero gallery videos are excluded — syncVid owns their play/pause. */
const vids=document.querySelectorAll('.fla5 video[autoplay]');
if(!vids.length||!('IntersectionObserver' in window))return;
const io=new IntersectionObserver(es=>es.forEach(e=>{
  const v=e.target;
  if(e.isIntersecting){if(v.paused)v.play().catch(()=>{});}
  else if(!v.paused)v.pause();
}),{threshold:.2});
vids.forEach(v=>io.observe(v));
})();
});
}
